// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setLivePreview = createAction('[Custom PDF Report Builder] Set Live Preview', props());
